import BaseRequest from './BaseRequest';

const schema = 'user';
/**
 * key base on host:port
 */
export default class UserRequest extends BaseRequest {
  /**
	 *
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchUserBalances() {
    const url = `${schema}/balances`;
    return this.get(url);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.password
	 * @param {string} params.email
	 * @param {string} params.country
	 * @param {string} params.home_address
	 * @param {string} params.postal_code
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  updateUserInfo(params) {
    const url = `${schema}/update-info`;
    return this.post(url, params);
  }

  fetchUserInfo() {
    const url = `${schema}/user-info`;
    return this.get(url);
  }

  fetchUserLoginHistory(params) {
    const url = `${schema}/user-login-history`;
    return this.get(url, params);
  }
}
